<template>
  <div>
    <Modal :footer-hide="true" :mask-closable="false" v-model="show" :title="row.name" :width="1000" @on-cancel="$emit('cancel')">
      <table class="QHtable" v-if="!$isblank(row)">
        <tr>
          <th style="width: 125px">单位信息</th>
          <th></th>
        </tr>
        <tr>
          <td style="width: 125px"><b>排放单位</b></td>
          <td>
            <span class="CL5" v-if="row.status == 100"><i class="MR3 iconfont icon-tongyi"></i>运营中</span>
            <span class="CL1" v-if="row.status == 200"><i class="MR3 iconfont icon-wenhao-quan"></i>已关闭</span>
            <span class="CL1" v-if="row.status == 300"><i class="MR3 iconfont icon-wenhao-quan"></i>未开通</span>
            <span class="CL1" v-if="row.status == 400"><i class="MR3 iconfont icon-wenhao-quan"></i>审核中</span>
            <span class="CL1" v-if="row.status == 500"><i class="MR3 iconfont icon-wenhao-quan"></i>未通过</span>
            <span> {{ row.name }}</span>
          </td>
        </tr>
        <tr>
          <td style="width: 125px"><b>通讯地址</b></td>
          <td>{{ row.addressFull }}</td>
        </tr>
        <tr>
          <td style="width: 125px"><b>联系姓名</b></td>
          <td>{{ row.contactName }}</td>
        </tr>
        <tr>
          <td style="width: 125px"><b>联系电话</b></td>
          <td>{{ row.contactTel }}</td>
        </tr>
        <tr v-for="(item, index) in row.orgQualification" :key="index">
          <td>
            <b>{{ $s("zizhiTypeTxt", item.zizhiType) || "其他资质" }}</b>
          </td>
          <td>
            <div class="flex-between">
              <div>
                <span class="MR5 CL4" v-if="$isYouxiaoqiNei(item.startTime, item.endTime)"><i class="MR3 iconfont icon-tongyi"></i>有效期内</span>
                <span class="MR5 CL5" v-else><i class="MR3 iconfont icon-wenhao-quan"></i>有效期外</span>
                <span>{{ item.name }}</span>
                <span style="white-space: nowrap">(有效期{{ $timeFmt(item.startTime, "YYYY年MM月DD日") }}至{{ $timeFmt(item.endTime, "YYYY年MM月DD日") }})</span>
              </div>
              <div class="flex-between" style="margin-left: 10px">
                <span class="QHset" style="white-space: nowrap" @click="$openImg($getFritImg(item.url))"> 查看 </span>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th style="width: 125px">排放权限</th>
          <th></th>
        </tr>
        <tr>
          <td style="width: 125px"><b>排放权限</b></td>
          <td>
            <span class="CL5" v-if="row.paifangAuth == 100"><i class="MR3 iconfont icon-tongyi"></i>已开通</span>
            <span class="CL1" v-if="row.paifangAuth == 200"><i class="MR3 iconfont icon-wenhao-quan"></i>已关闭</span>
            <span class="CL1" v-if="row.paifangAuth == 300"><i class="MR3 iconfont icon-wenhao-quan"></i>待提审</span>
            <span class="CL1" v-if="row.paifangAuth == 400"><i class="MR3 iconfont icon-wenhao-quan"></i>审核中</span>
            <span class="CL1" v-if="row.paifangAuth == 500"><i class="MR3 iconfont icon-wenhao-quan"></i>已拒绝</span>
          </td>
        </tr>
        <tr v-for="(item, index) in row.orgRoleQualification" :key="index">
          <td>
            <b>{{ $s("zizhiTypeTxt", item.zizhiType) || "其他资质" }}</b>
          </td>
          <td>
            <div class="flex-between">
              <div>
                <span class="MR5 CL5" v-if="$isYouxiaoqiNei(item.startTime, item.endTime)"><i class="MR3 iconfont icon-tongyi"></i>有效期内</span>
                <span class="MR5 CL1" v-else><i class="MR3 iconfont icon-wenhao-quan"></i>有效期外</span>
                <span>{{ item.name }}</span>
                <span style="white-space: nowrap">(有效期{{ $timeFmt(item.startTime, "YYYY年MM月DD日") }}至{{ $timeFmt(item.endTime, "YYYY年MM月DD日") }})</span>
              </div>
              <div class="flex-between" style="margin-left: 10px">
                <span class="QHset" style="white-space: nowrap" @click="$openImg($getFritImg(item.url))"> 查看 </span>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </Modal>
  </div>
</template>
<script>
export default {
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      Checkbox: true,
      show: false,
      row: {},
    };
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:弹窗详情
    // +----------------------------------------------------------------------
    hiPop(e) {
      //参数整合与接口
      var that = this;
      var https = {
        type: "isRow",
        api: this.$api.getOrgpaifangDetailed,
        parameter: {
          id: e.id,
        },
      };
      this.$httpsApi(https, function (res) {
        that.title = res.data.name;
        that.show = true;
      });
    },
  },
};
</script>
